import React from "react";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import { formatNumber } from "../../../../../../utils/NumberHelpers";
import {
    adjustButtonMargin,
    adjustPriceActionMargin,
    ExpandedContent,
    isOldPrice,
    isReduction,
    isTotal,
    PriceLabel,
    PriceValue,
    ProductDetails,
    ProductRow,
    ProductRowLabel,
    ProductRowValue,
    ProductRowValueAddition,
    ToggleMore,
} from "../../../../../shared/CalculatorProductDetails";
import List from "../../../../../shared/List";
import Button from "../../../../../shared/NewForms/Button";
import useCalulatorStore from "../../store";

const Benefits = styled.div`
    margin-top: 20px;
    font-weight: 500;
`;

const ProductInformationWrapper = styled.div`
    min-height: 150px;
`;

const Product = ({
    amount,
    product,
    onSubmit,
    expanded,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onExpand = () => {},
}) => {
    const theme = useTheme();

    const [additions, result] = useCalulatorStore((state) => [
        state.additions,
        state.result,
    ]);

    const resultHasActivePriceActions =
        result.filter((product) => product.prices.totalWithAction !== null)
            .length > 0;

    return (
        additions && (
            <ProductDetails>
                <ProductInformationWrapper>
                    <ProductRow>
                        <ProductRowLabel>Menge:</ProductRowLabel>
                        <ProductRowValue>
                            {formatNumber(amount)}&nbsp;l
                        </ProductRowValue>
                    </ProductRow>
                    <ProductRow>
                        <ProductRowLabel>Lieferzeit:</ProductRowLabel>
                        <ProductRowValue>
                            max. {product.days} Werktage{" "}
                            <ProductRowValueAddition>
                                (Mo-Fr)
                            </ProductRowValueAddition>
                        </ProductRowValue>
                    </ProductRow>
                    <ProductRow>
                        <ProductRowLabel>Heizölqualität:</ProductRowLabel>
                        <ProductRowValue>
                            {product.isPremium
                                ? "Eco-Super-Heizöl"
                                : "Standard"}
                        </ProductRowValue>
                    </ProductRow>
                </ProductInformationWrapper>
                {product.prices.totalWithAction ? (
                    <>
                        <ProductRow>
                            <PriceLabel css={isTotal}>Gesamt:</PriceLabel>
                            <PriceValue css={isOldPrice}>
                                {product.prices.priceTotalGross}&nbsp;&euro;
                            </PriceValue>
                        </ProductRow>
                        <ProductRow>
                            <PriceLabel>Abzüglich:</PriceLabel>
                            <PriceValue css={isReduction({ theme })}>
                                -{product.prices.priceActionDifference}
                                &nbsp;&euro;
                            </PriceValue>
                        </ProductRow>
                        <ProductRow>
                            <PriceLabel css={isTotal}>Gesamt:</PriceLabel>
                            <PriceValue>
                                {product.prices.totalWithAction}
                                &nbsp;&euro;*
                            </PriceValue>
                        </ProductRow>
                    </>
                ) : (
                    <>
                        <ProductRow
                            css={css`
                                ${resultHasActivePriceActions &&
                                adjustPriceActionMargin}
                            `}
                        >
                            <PriceLabel css={isTotal}>Gesamt:</PriceLabel>
                            <PriceValue css={isTotal}>
                                {product.prices.priceTotalGross}&nbsp;&euro;
                            </PriceValue>
                        </ProductRow>
                    </>
                )}
                <Button
                    color="red"
                    css={adjustButtonMargin}
                    fullWidth
                    onClick={onSubmit}
                >
                    Bestellen
                </Button>

                <ToggleMore onClick={onExpand}>
                    {expanded ? "Weniger Details -" : "Mehr Details +"}
                </ToggleMore>

                {expanded && (
                    <ExpandedContent>
                        <ProductRow>
                            <ProductRowLabel>
                                inkl. ADR und Maut
                            </ProductRowLabel>
                            <ProductRowValue>
                                {additions.ggvs_add}&nbsp;&euro;
                            </ProductRowValue>
                        </ProductRow>
                        <Benefits>Ihre Vorteile auf einen Blick</Benefits>
                        <List>
                            {product.description.map((desc, idx) => (
                                <List.Item key={idx}>{desc}</List.Item>
                            ))}
                        </List>
                    </ExpandedContent>
                )}
            </ProductDetails>
        )
    );
};

export default Product;
